import {
  type HotelLocationAutocompleteProps,
  useHotelLocationAutocomplete as useCoreHotelLocationAutocomplete,
} from "@b2bportal/core-hotels";
import { useI18nContext } from "@hopper-b2b/i18n";

export const useHotelLocationAutocomplete = (
  props: HotelLocationAutocompleteProps
) => {
  const { t } = useI18nContext();
  const { context, handlers } = useCoreHotelLocationAutocomplete(props);

  return {
    context: {
      ...context,
      placeholder: t("core-hotels.search.location.placeholder"),
      mobileDialogTitle: t("core-hotels.search.location.mobileTitle"),
    },
    handlers,
  };
};
